<template>
  <div class="e-dialogswrapper">
    <transition name="slide-to-left">
      <MessageList
        v-show="!dialogOpen"
        :items="messagesSent"
        :is-loading="loadingSents"
        :show-new-dialog-button="false"
        :selected-item-id="$route.params.messageId"
        :loading-item-id="loadingId"
        @select="onDialogSelection"
      />
    </transition>

    <transition mode="out-in" name="dialog-container">
      <DialogWrapper v-if="dialogOpen" :key="'dialog' + currentDialogId" />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import DialogWrapper from 'organisms/DialogWrapper/DialogWrapper'
import MessageList from 'organisms/MessageList/MessageList'
import DialogModel from 'store/models/Dialog'
import DialogMessageModel from 'store/models/DialogMessage'

export default {
  name: 'SentTemplate',
  components: {
    DialogWrapper,
    MessageList
  },
  data() {
    return {
      selectedMessage: {
        type: Object,
        default: null
      },
      loadingId: null,
      messagesSent: []
    }
  },
  computed: {
    ...mapGetters([
      'currentDialog',
      'currentDialogId',
      'currentRouteName',
      'dialogOpen',
      'loadingSents',
      'userId'
    ]),
    dialogSelected() {
      return typeof this.currentDialogId !== 'undefined'
    }
  },
  watch: {
    currentDialogId: {
      handler: async function(newVal, oldVal) {
        if (newVal !== oldVal) {
          await this.loadDialog()
        }
        this.setDialogOpen(this.dialogSelected)
      },
      immediate: true
    }
  },
  async mounted() {
    this.messagesSent = await DialogMessageModel.fetchMessagesSent(this.userId)
  },
  methods: {
    ...mapActions(['setDialogOpen']),
    async loadDialog() {
      if (this.currentDialogId) {
        this.loadingId = this.selectedMessage.id
        await DialogModel.fetchById(this.userId, this.currentDialogId)

        await DialogMessageModel.fetchDialogMessages(
          this.userId,
          this.currentDialogId
        )
        this.loadingId = null
      }
    },
    onDialogSelection(dialog) {
      this.selectedMessage = dialog
      if (dialog === null) {
        this.$router.push({ name: 'sent' })
        return
      }
      this.$router.push({
        name: 'sentDialog',
        params: {
          dialogId: dialog.rootId,
          messageId: dialog.id
        }
      })
    }
  }
}
</script>

<style lang="scss"></style>
